import { BENCHED, queryFieldPositions } from './constants'

export function deepCopy<T>(obj: T): T {
	return JSON.parse(JSON.stringify(obj))
}

export function calculatePositions(numPlayers: number, gameFormat: GameFormat): FieldPosition[] {
	const fieldPositions = queryFieldPositions(gameFormat)
	const positions: FieldPosition[] = fieldPositions.slice()
	for (let i = fieldPositions.length; i < numPlayers; i += 1) {
		positions.push(BENCHED)
	}
	return positions
}
